import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { TextNoteDialogOptions } from "./textnote-dialog";
import { TextNoteDialogComponent } from "./textnote-dialog.component";


@Injectable()
export class TextNoteDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Text Note Dialog Service Call

    Open(options?: TextNoteDialogOptions): Observable<string> {
        const self = this;

        const openHandle = self.matDialog.open<TextNoteDialogComponent>(TextNoteDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Information Requested',
                MessageText: '',
                ...options,
            },
            panelClass: 'textNoteDialog',
            width: '1000px',
            minWidth: '1000px',
            maxWidth: '1000px',
            height: '40rem',
            minHeight: '40rem',
            maxHeight: '40rem',
        });

        return openHandle.afterClosed();
    }

    // #endregion
}